import { IssueFormEntity } from 'serviceWorker/repository/issueForm/issueForm';

/** Why the issue forms were not requested: what the request needs is missing. */
export enum IssueFormSkipReason {
  /** No API address or project in the config, or the pull was aborted. */
  notRequestable = 'notRequestable',
  noSelectedProject = 'noSelectedProject',
  /** The permissions to the project are not stored (yet): they are downloaded apart from the data. */
  permissionsNotStored = 'permissionsNotStored',
}

export type IssueFormFetchResult =
  | { isDownloaded: true; issueForms: IssueFormEntity[] }
  | { isDownloaded: false; skipReason: IssueFormSkipReason };

export const skippedIssueFormFetch = (skipReason: IssueFormSkipReason): IssueFormFetchResult => ({
  isDownloaded: false,
  skipReason,
});
